import axios from 'axios';

class VariantListService {

  getVariants(onUploadProgress, url, oncokbkey="") {

    //alert(localStorage.getItem("oncokbKey"))
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "oncokb-key": localStorage.getItem("oncokbKey")
      },
      onUploadProgress
    });

  }
}

export default new VariantListService();
